import {defineStore} from 'pinia'
import {Helpers} from "@/helpers";
import dayjs from "dayjs";
import {NANO_EVENT_TYPES} from "@/scripts/constants";

export const useContractStore = defineStore({
    // name of the store
    // it is used in devtools and allows restoring state
    id: 'contract',
    // a function that returns a fresh state
    state: () => ({
        contracts: [],
        itemLength: 0,
        loading: false,
        serverOptions: {
            page: 0,
            rows: 25,
            sortBy: 'age',
            sortType: 'desc',
            filters: {},
        }
    }),
    // optional getters
    getters: {},
    // optional actions
    actions: {
        store(data) {
            return this.apiClient.post(`/contracts`, data)
        },
        index(clientId = null) {
            this.loading = true
            const params = {
                page: this.serverOptions.page + 1,
                size: this.serverOptions.rows
            }
            const filters = this.serverOptions.filters || {}
            const filteredClientId = filters.client_id?.value
            if (clientId || filteredClientId) {
                params.client_id = clientId || filteredClientId
            }
            if (filters.title?.value?.trim()) {
                params.title = filters.title.value.trim()
            }
            if (filters.info?.value?.trim()) {
                params.info = filters.info.value.trim()
            }
            if (filters.contract_status_ids?.value?.length) {
                params.contract_status_ids = filters.contract_status_ids.value.join(',')
            }
            const contractDateRange = filters.contract_date?.value
            if (contractDateRange?.[0]) {
                params.contract_date_from = dayjs(contractDateRange[0]).format('YYYY-MM-DD')
            }
            if (contractDateRange?.[1]) {
                params.contract_date_to = dayjs(contractDateRange[1]).format('YYYY-MM-DD')
            }
            return this.apiClient.get(`/contracts`, {
                params
            }).then(({data}) => {
                this.contracts = data.contracts
                this.itemLength = data.itemLength
            }).finally(() => {
                this.loading = false
            })
        },
        get(id) {
            return this.apiClient.get(`/contracts/${id}`)
        },
        update(id, data) {
            return this.apiClient.put(`/contracts/${id}`, data)
        },
        updateGeneralTermAssignment(id, attributes) {
            return this.apiClient.put(`/contract_general_term_assignments/${id}`, {
                contract_general_term_assignment: attributes,
            })
        },
        setOnline(id, contractStatusId) {
            return this.apiClient.put(`/contracts/${id}`, {contract: {
                    start_at: dayjs(),
                    contract_status_id: contractStatusId,
                }}).then(({data}) => {
                console.log(JSON.stringify(data))
                Helpers.emitter.emit(NANO_EVENT_TYPES.CONTRACT_CHANGED)
            }).catch( (error) => {
                if (error.response) {
                    Helpers.emitter.emit('error', error.response.data.messages)
                    // console.log(error.response.status);
                }else {
                    Helpers.emitter.emit('error', "unknown error - check console!")
                    console.error(JSON.stringify(error))
                }
            })
        }
    },
})
